import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { LanguageService } from '@shared/partner-ui/services/language.service';
import { ToastService } from '../services/toast.service';

export const impersonationErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);
  const language = inject(LanguageService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 403 && error.error?.code === 'impersonation_read_only') {
        toast.error(language.translate('impersonation.messages.readOnly'));
      }

      return throwError(() => error);
    })
  );
};
